module.exports = __webpack_public_path__ + "img/Monte_Kope_83.f2bb2d76.jpg";